import React from "react";

export const Eyebrow = ({ children, style }) => (
  <div className="eyebrow" style={style}>{children}</div>
);

export function TierStamp({ tier }) {
  const t = String(tier ?? "2");
  const cls = t.startsWith("3") ? "tier3" : t.startsWith("1") ? "tier1" : t.startsWith("0") ? "tier0" : "tier2";
  return <span className={`stamp ${cls}`}>Tier {t}</span>;
}

export function SlaClock({ dueAt }) {
  if (!dueAt) return <span className="mono" style={{ fontSize: 11 }}>—</span>;
  const ms = dueAt.toMillis ? dueAt.toMillis() - Date.now() : new Date(dueAt) - Date.now();
  const hrs = Math.round(ms / 36e5);
  const late = hrs < 0;
  return (
    <span className={`mono ${late ? "fail" : ""}`} style={{ fontSize: 11 }}>
      {late ? `${Math.abs(hrs)}h over` : `${hrs}h left`}
    </span>
  );
}

export function CheckList({ l1 }) {
  if (!l1) return <p style={{ color: "var(--graphite)" }}>L1 has not run on this submission yet.</p>;
  const entries = Object.entries(l1.checks ?? {});
  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 13 }}>
      {entries.map(([k, v]) => (
        <li key={k} className="row" style={{ gap: 8, padding: "2px 0" }}>
          <span className={v ? "pass" : "fail"} style={{ width: 14 }}>{v ? "✓" : "✕"}</span>
          <span className="mono" style={{ fontSize: 12 }}>{k}</span>
          {!v && l1.failedHard?.includes(k) && <span className="pill fail">blocks queue</span>}
        </li>
      ))}
    </ul>
  );
}
